module.exports = __webpack_public_path__ + "files/f84cb1bf9be983133497000554605b4d.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Roboto-regular.woff2
// module id = 784
// module chunks = 60